import { Link as _Link } from 'react-router-dom';
import { styled } from '@material-ui/core';
import { COLOR_TEXT_LINK } from '../../../../theme/colors';

// https://www.figma.com/file/oy0lqfg1RnOZ1Y7129AJmc/KAIZEN-Design-Library?node-id=40%3A11173
export const Link = styled(_Link)({
  color: COLOR_TEXT_LINK,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
});

export const LeftFloatLink = styled(_Link)({
  color: COLOR_TEXT_LINK,
  float: 'left',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
});

export default Link;
